import * as intersectionObserver from 'intersection-observer';

function lazyLoadImages() {
  let elements = document.querySelectorAll('[data-sal-src]');

  let observer = new window.IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let element = entry.target;
        console.log(element);
        const tagName = element.tagName;

        if (tagName === 'IMG' || tagName === 'VIDEO') {
          element.src = element.getAttribute('data-sal-src');
          const srcSet = element.getAttribute('data-sal-srcset');
          if (srcSet) {
            element.srcset = srcSet;
          }
          console.log(element);
        } else {
          observer.unobserve(element);
          return;

          const url = element.getAttribute('data-sal-src');
          element.style.backgroundImage = `url('${url}')`;
        }

        // console.log(`loaded ${element.src}`);
        observer.unobserve(element);
      }
    });
  });

  elements.forEach(element => {
    observer.observe(element);
  });
}

function loadDeferredResources() {
  if (!window.salDeferredResources) return;

  window.salDeferredResources.forEach((str) => {
    if (str.endsWith('.css')) {
      let link = document.createElement('link');
      link.href = str;
      link.type = 'text/css';
      link.rel = 'stylesheet';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  });
}

function loadImages() {
  let elements = document.querySelectorAll('[data-sal-src]');

  elements.forEach((element) => {
    const tagName = element.tagName.toLowerCase();
    if (tagName === 'img' || tagName === 'video') {
      element.src = element.getAttribute('data-sal-src');
    } else {
      element.style.backgroundImage =
          `url('${element.getAttribute('data-sal-src')}')`;
    }
  });
}


// adapted from from stack overflow;
// returns undefined if key is not in the query string.
function getUrlParameter(key) {
  const query = location.search.substring(1);

  // from stack overflow exactly
  const vars = query.split('&');
  const query_string = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    // If first entry with this name
    if (typeof query_string[pair[0]] === 'undefined') {
      query_string[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
    } else if (typeof query_string[pair[0]] === 'string') {
      const arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
      query_string[pair[0]] = arr;
      // If third or later entry with this name
    } else {
      query_string[pair[0]].push(decodeURIComponent(pair[1]));
    }
  }
  // end SO

  if (key in query_string) {
    return query_string[key];
  }
  return undefined;
}

// returns a promise that resolves then the page is done loading.
function waitForPageLoad() {
  return new Promise((resolve, reject) => {
    window.addEventListener('load', () => {
      resolve();
    });
  });
}
// from SO:
function setCookie(name, value) {
  // document.cookie = `${name}=${value};expires=${expires};
  // domain=saleae.com;"`; document.cookie =
  // `${name}-localhost=${value};expires=${expires};"`; // localhost cookie
  // requires no domain

  let rootDomain = getRootDomain();
  let cookie = '';

  if (getEnvironment() !== 'dev') {
    cookie = `${name}=${value}; domain=${rootDomain}; path=/`;
    document.cookie = cookie;

    if (getCookie(name) === null) {
      // try saving with the full subdomain
      cookie = `${name}=${value}; domain=${window.location.hostname}; path=/`;
      document.cookie = cookie;
      // I think this works on *.netlify.com because somehow the
      // header is indicating it doesn't allow cross-subdomain cookies, which
      // normally we want.
    }
  } else {
    cookie = `${name}-localhost=${
        value}; path=/`;  // localhost cookie requires no domain
    document.cookie = cookie;
  }
}

function getCookie(name) {
  let nameEQ = `${name}=`;

  if (getEnvironment() === 'dev') nameEQ = `${name}-localhost=`;

  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  // document.cookie = `${name}=; Max-Age=-99999999;`; //max-age causes IE11 to
  // fail - possibly edge too
  if (getEnvironment() !== 'dev')
    document.cookie = `${name}=;`;
  else
    document.cookie = `${name}-localhost=;`;
}

// returns Windows, Mac, or Linux
function guessOperatingSystem() {
  const appVersion = navigator.appVersion.toLowerCase();
  if (appVersion.includes('win')) return 'Windows';
  if (appVersion.includes('mac')) return 'Mac OSX';
  if (appVersion.includes('linux')) return 'Linux';
  if (appVersion.includes('x11')) return 'Linux';

  return 'Windows';
}

function getEnvironment() {
  const url = window.location.href;
  if (url.includes('localhost') || url.includes('192.168') ||
      url.includes('127.0.0.1')) {
    return 'dev';
  }
  if (url.includes('staging.')) {
    return 'staging';
  }
  return 'production';
}

function getWwwRootUrl() {
  const env = getEnvironment();
  switch (env) {
    case 'production':
      return 'https://www.saleae.com';
    // return 'https://staging.www.saleae.com';
    case 'staging':
      return 'https://staging-www-saleae-com.netlify.app/';
    case 'dev':
      return 'https://localhost:4000';
  }
}

function getRootDomain() {
  const parts = window.location.hostname.split('.');
  const len = parts.length;
  const rootDomain = parts[len - 2] + '.' + parts[len - 1];
  return rootDomain;
}

function isOnWww() {
  let url = window.location.href;
  let root = getWwwRootUrl();
  if (url.startsWith(root))
    return true;
  else
    return false;
}

// https://dev.to/ycmjason/javascript-fetch-retry-upon-failure-3p6g
const fetchRetry = (url, options, n) =>
    fetch(url, options).catch(function(error) {
      if (n === 1) throw error;
      return fetchRetry(url, options, n - 1);
    });

// Note: this is treated as async by default.  Otherwise would need to set
// script.async=false
function injectScript(url, onLoad) {
  let head = document.getElementsByTagName('head')[0];
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.onload = onLoad;
  script.src = url;
  head.appendChild(script);
}

let finishedCallbacks = [];
let finishedComplete = false;
function callOnFinished(f) {
  if (finishedComplete) {
    f();
  } else {
    finishedCallbacks.push(f);
  }
}

function finished() {
  finishedComplete = true;
  finishedCallbacks.forEach(f => f());
}

function callOnLoaded(f) {
  if (document.readyState !== 'loading') {
    f();
  } else {
    window.addEventListener('load', () => {
      f();
    });
  }
}


function getPerformance() {
  // note window.performance.timing is a read-only property
  let performance = {};
  let navigationStart = window.performance.timing.navigationStart;
  performance['navigationStart'] = 0;

  for (let element in window.performance.timing) {
    if (element === 'navigationStart') continue;

    let value = window.performance.timing[element];
    if (value === 0)
      performance[element] = 0;
    else
      performance[element] =
          (window.performance.timing[element] - navigationStart) / 1000;
  };
  return performance;
}

function getTimeSinceNavigationStart() {
  const nowTime = (new Date).getTime();  // in ms since epoch
  const deltaTime =
      (nowTime - window.performance.timing.navigationStart) / 1000;
  return deltaTime;
}

function isHomePage() {
  const homepageHostnames = ['static.saleae.com', 'www.saleae.com'];
  const { hostname } = window.location;
  if (homepageHostnames.includes(hostname) || hostname.endsWith('netlify.app')) {
    return true
  }
  return false;
}

function isBlog() {
  const blogHostnames = ['blog.saleae.com'];
  const { hostname } = window.location;
  if (blogHostnames.includes(hostname)) {
    return true
  }
  return false;
}

function isSupport() {
  const supportHostnames = ['contact.saleae.com'];
  const { hostname } = window.location;
  if (supportHostnames.includes(hostname)) {
    return true
  }
  return false;
}

export {
  getUrlParameter,
  waitForPageLoad,
  setCookie,
  getCookie,
  eraseCookie,
  guessOperatingSystem,
  getEnvironment,
  getWwwRootUrl,
  getRootDomain,
  isOnWww,
  fetchRetry,
  loadDeferredResources,
  loadImages,
  lazyLoadImages,
  injectScript,
  callOnFinished,
  finished,
  callOnLoaded,
  getPerformance,
  getTimeSinceNavigationStart,
  isHomePage,
  isBlog,
  isSupport,
};
